export default "__VITE_ASSET__DkilGtQ6__"